import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModuleV1Read, SingleResponse, WorkflowV1Read, WorkflowV1Save } from '@ca/core/models';
import { DomainFactoryService, UserNotificationService, UserWorkspaceService, WorkflowV1Service } from '@ca/core/services';
import { CustomValidators, FormUtils } from '@ca/utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { mapTo, mergeMap } from 'rxjs/operators';

@Component({
    selector: 'ca-workflow-creator',
    templateUrl: './workflow-creator.component.html',
    styleUrls: ['./workflow-creator.component.scss'],
})
export class WorkflowCreatorComponent implements OnInit {
    @Input() isPublicModule: boolean = false;
    @Input() module?: ModuleV1Read;

    formGroup: UntypedFormGroup;
    title: string;
    isSubmitting: boolean = false;

    constructor(
        private userWorkspaceService: UserWorkspaceService,
        private activeModal: NgbActiveModal,
        private userNotificationService: UserNotificationService,
        private workflowV1Service: WorkflowV1Service,
        private domainFactory: DomainFactoryService,
        private formBuilder: UntypedFormBuilder,
    ) {}

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            title: [this.title, CustomValidators.ModelTitle()],
            shouldUseTestFiles: [true],
        });
    }

    submit(): void {
        if (FormUtils.isValidForm(this.formGroup)) {
            this.isSubmitting = true;
            this.userNotificationService.showSpinner();
            const workflow = this.domainFactory.createNewWorkflowFromModuleWithDefineInput(
                this.module,
                this.formGroup.get('shouldUseTestFiles')!.value as boolean,
            );
            workflow.title = this.formGroup.value.title.trim();
            this.workflowV1Service
                .create(new WorkflowV1Save(workflow.getReadModelV1()))
                .pipe(
                    mergeMap((res: SingleResponse<WorkflowV1Read>) => {
                        // after creating a workflow, update the count and return the original result
                        return this.userWorkspaceService.updateMyWorkflows$().pipe(mapTo(res));
                    }),
                )
                .subscribe(
                    (res: SingleResponse<WorkflowV1Read>) => {
                        this.userNotificationService.hideSpinner();
                        this.activeModal.close(res);
                    },
                    (error: HttpErrorResponse) => {
                        this.isSubmitting = false;
                        if (error.error) {
                            this.userNotificationService.showError('Failed to create Workflow');
                        }
                        this.userNotificationService.hideSpinner();
                    },
                );
        }
    }

    dismiss(reason?: string): void {
        this.activeModal.dismiss(reason);
    }
}
